<!--成本设置-->
<template>
  <el-form ref="form" label-width="80px" size="mini">
    <div class="row-wrap" style="padding-left:30px;">
      <h4 style="padding-left:15px;">汇率和成本设置</h4>
      <el-row>
        <el-col :xs="24">
          <el-form-item :label="msg('运费成本(CNY)：')" label-width="130px">
            <el-input-number v-model="expCost" controls-position="right" :min="0" :max="100"></el-input-number>
            <span style="margin-left: 5px;font-size: 16px;font-weight: bold;">元/KG</span>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('打包成本(CNY)：')" label-width="130px">
            <el-input-number v-model="dabaoCost" controls-position="right" :min="0" :max="100"></el-input-number>
            <span style="margin-left: 5px;font-size: 16px;font-weight: bold;">元</span>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('进店成本(CNY)：')" label-width="130px">
            <el-input-number v-model="jindianCost" controls-position="right" :min="0" :max="100"></el-input-number>
            <span style="margin-left: 5px;font-size: 16px;font-weight: bold;">元</span>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('其他成本(CNY)：')" label-width="130px">
            <el-input-number v-model="otherCost" controls-position="right" :min="0" :max="100"></el-input-number>
            <span style="margin-left: 5px;font-size: 16px;font-weight: bold;">元</span>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item :label="msg('参考汇率：')" label-width="130px">
            <el-input-number v-model="rate" controls-position="right" :step="0.1" :min="1" :max="10"></el-input-number>
            <span style="margin-left: 5px;font-size: 16px;font-weight: bold;">TWD = </span>
            <span style="margin-right: 5px;font-size: 16px;font-weight: bold;"><span style="font-size: 20px;color: #FF4D4F;">1&nbsp;</span>CNY</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingCost",
  data() {
    return {
      xgroup: 'COST_GROUP',  //成本设置group
      costObj: null,
      rate: 4.5, // 参考汇率
      expCost: 0, // 运费成本
      dabaoCost: 0, // 打包成本
      jindianCost: 0, // 进店成本
      otherCost: 0, // 其他成本
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      if (data.length > 0) {
        this.costObj = data[0];
        let set = JSON.parse(data[0].xvalue);
        this.rate = set.rate;
        this.expCost = set.expCost;
        this.dabaoCost = set.dabaoCost;
        this.jindianCost = set.jindianCost;
        this.otherCost = set.otherCost;
      }
    },
    update() {
      let datas = [];
      if (this.costObj) {
        this.costObj.xvalue = JSON.stringify({
            rate: this.rate,
            expCost: this.expCost,
            dabaoCost: this.dabaoCost,
            jindianCost: this.jindianCost,
            otherCost: this.otherCost,
          }),
        datas.push(this.costObj);
      } else {
        this.costObj = {
          id: null,
          xkey: this.xgroup,
          owner: null,
          xgroup: this.xgroup,
          xvalue: JSON.stringify({
            rate: this.rate,
            expCost: this.expCost,
            dabaoCost: this.dabaoCost,
            jindianCost: this.jindianCost,
            otherCost: this.otherCost,
          }),
          xtype: 0
        }
        datas.push(this.costObj);
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>